export const AboutPanelContent = () => {
  return (
    <div>
      <h3>{"Feedback"}</h3>
      <p>
        Please explore different features and provide feedback on functionality,
        responsiveness, and any bugs you encounter. You can use the thumbs
        up/down buttons on the answers of the chatbot to share your feedback
        with the developers.
      </p>
      <h3>{"Privacy Statement"}</h3>
      <p>
        MB Energy is committed to protecting your privacy. The MB Energy chatbot
        does not collect or store the content of your chat sessions. However, if
        you provide negative feedback about a chat interaction (via the thumbs
        down button), we will collect and store the following information for
        quality improvement purposes:
        <ul>
          <li>Your User ID</li>
          <li>The question you asked</li>
          <li>The chatbot response</li>
          <li>Any document content related to your query</li>
          <li>Your feedback</li>
        </ul>
        This data is only used for troubleshooting and enhancing the performance
        of the chatbot. It is not stored with third parties or used for any
        other purpose. If you have any questions or concerns about how your data
        is handled, please contact us at{" "}
        <a href="mailto: map-mabachat-monitoring@mbenergy.com?subject=Mabachat%20HR%20Feedback">
          map-mabachat-monitoring@mbenergy.com
        </a>
      </p>
    </div>
  );
};
